<template>
  <div>
    <v-runtime-template :template="includeTemplate"/>
    <div v-if="visible">
      <v-runtime-template :template="includeTempYoutube"/>
    </div>
  </div>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'

export default {
  name: 'Forum',
  components: {
    VRuntimeTemplate
  },
  data () {
    return {
      includeHtml: '',
      includeYoutubeHtml: '',
      visible: false,
      videoSrc: '',
      options: {
        height: '100%',
        color: '#ccc',
        opacity: 1,
        size: '.6rem',
        distance: '1rem',
        disableFadeOut: true,
        alwaysVisible: true
      },
      basePath: this.getStore('mmpAuth').state.basePath
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    },
    includeTempYoutube () {
      return this.includeYoutubeHtml
    }
  },
  watch: {
  },
  beforeUpdate () {
  },
  updated () {
  },
  async created () {
    if (isEmpty(wepHtmlToString.mainTemplate)) {
      this.getEmptyTemplate('wepForum.html')
    } else {
      this.includeHtml = wepHtmlToString.mainTemplate
    }

    this.getTemplateYoutube()
  },
  methods: {
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.mainTemplate = res
        this.includeHtml = wepHtmlToString.mainTemplate
      })
    },
    getTemplateYoutube () {
      let resourceYoutubeUrl = this.getTemplatePath('wepYoutube.html')
      this.$http.loadRes(resourceYoutubeUrl).then( (res) => {
        this.includeYoutubeHtml = res
      })
    },
    closeYoutube () {
      this.visible = false
      this.setOverflow(this.visible)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/Forum.vue